import {FC, useState} from "react";
import {Alert, Button, Checkbox, Flex, Spin, Typography} from "antd";
import {useOwnProfile} from "../../stores/OwnProfileStore.ts";
import {LinkOutlined} from "@ant-design/icons";
import {useTelegramLink} from "../../queries/useTelegramLink.ts";
import styles from './SettingsPage.module.css';
import {ContactsForm} from "./components/ContactsForm/ContactsForm.tsx";
import {useUserContacts} from "../../queries/useUserContacts.ts";

export const SettingsPage: FC = () => {
    const { profile } = useOwnProfile();
    const { data } = useTelegramLink();
    const { data: contacts } = useUserContacts(profile?.id || 0, !!profile);
    const [addTgToContacts, setAddTgToContacts] = useState(true);

    return (
        <div className={styles.wrapper}>
           <Flex vertical gap={16}>
               <Typography.Title level={2}>Настройки</Typography.Title>
               <Flex vertical gap={12}>
                   <Flex vertical gap={6}>
                       <Typography.Title level={3}>Уведомления в Telegram</Typography.Title>
                       <Typography.Text>
                           Для получения уведомлений в Telegram привяжите профиль кнопкой ниже
                       </Typography.Text>
                       <Typography.Text>
                           Привязка происходит по уникальному внутреннему коду, зашитому в ссылке — не по VATSIM CID или Telegram ID<br />
                           Это значит, что никто не сможет “угадать” или подделать привязку — даже если знает ваш Telegram и имя бота
                       </Typography.Text>
                   </Flex>
                   <Flex align="center" gap={16}>
                       {profile?.telegram_linked ? (
                           <>
                               <Typography.Text strong>Аккаунт привязан</Typography.Text>
                               <Button icon={<LinkOutlined />} href={data?.link} target="_blank">Привязать другой</Button>
                           </>
                       ) : (
                           <Flex align="center" gap={8}>
                               <Button
                                   icon={<LinkOutlined />}
                                   type="primary"
                                   href={addTgToContacts ? `${data?.link}_add` : data?.link}
                                   target="_blank"
                               >Привязать</Button>
                               <Checkbox
                                   checked={addTgToContacts}
                                   onChange={({ target }) => setAddTgToContacts(target.checked)}
                               >Добавить привязанный Telegram в контактную информацию</Checkbox>
                           </Flex>
                       )}
                   </Flex>
               </Flex>
               <Flex vertical gap={12}>
                   <Flex vertical gap={6}>
                       <Typography.Title level={3}>Контактная информация</Typography.Title>
                       <Typography.Text>
                           Вы можете задать контактную информацию, которая будет доступна для просмотра всем пользователям системы
                       </Typography.Text>
                       {contacts && !contacts.some(({ type }) => type === 'discord') && (
                           <Alert type='warning' showIcon message="Пожалуйста, укажите свой Discord" />
                       )}
                   </Flex>
                   {contacts ? <ContactsForm contacts={contacts} /> : <Spin />}
               </Flex>
           </Flex>
        </div>
    );
}